import { IUserLog } from "bets.oddprovider.lib.common.ts/models"
import { FilterQuery } from "mongoose"
import React from "react"
import { LogsGetWhereComponent } from "../logs/logsGetWhere"
import { UserLogsTableComponent } from "../logs/logsGrid"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { HeaderComponent } from "../common/header"
import { DEFAULTGAP } from "../../globals"

export interface UserLogsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  userId: number,
  onChangeParams?: ((filter: FilterQuery<IUserLog>) => void) | undefined,
  onSearchClick?: (() => void) | undefined,

  logs: IUserLog[] | undefined,
  onRefreshClick?: () => void
}

export const UserLogsComponent = (props: UserLogsComponentProps) => {
  const { userId, onChangeParams, onSearchClick, logs, onRefreshClick: onRefreshClck, ...rest } = props

  return <div
    {...rest}

    style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      ...rest.style
    }}
  >
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <HeaderComponent
          title=''
          onRefreshClick={props.onRefreshClick}
        />
      </FormItemStyled>
    </FormStyled>
    <LogsGetWhereComponent
      userId={props.userId}
      onChange={props.onChangeParams}
      onSearchClick={props.onSearchClick}
    />
    <UserLogsTableComponent
      hideUserColumn={true}
      logs={props.logs}
      onRefreshClick={props.onRefreshClick}
    />
  </div>
}